import React from 'react';
import PropTypes from 'prop-types';
import RCTooltip from 'rc-tooltip';
import classnames from 'classnames';

import { GlobalTooltipStyle } from './TooltipStyles';
import { DarkTheme } from './themes/darkTheme';
import { LightTheme } from './themes/lightTheme';
import { DarkGrayTheme } from './themes/darkGrayTheme';

export const TOOLTIP_CLASS_PREFIX = 'bl-tooltip';
export const TOOLTIP_DELAY = 0.3;
export const TRIGGER_ENUM = {
  CLICK: 'click',
  HOVER: 'hover',
  FOCUS: 'focus',
};
export const PLACEMENT_ENUM = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_RIGHT: 'bottomRight',
};
export const THEME_ENUM = {
  DARK: 'dark-theme',
  DARK_GRAY: 'dark-gray-theme',
  LIGHT: 'light-theme',
};

export const Tooltip = React.memo(props => {
  const {
    children,
    offset,
    hide,
    theme,
    overlayClass,
    trigger,
    mouseEnterDelay,
    hover,
    withPaddings,
    tooltipRef,
  } = props;
  const className = classnames(overlayClass, theme, { hover, 'with-paddings': withPaddings });

  const internalProps = {};
  if (hide) internalProps.visible = false;

  return (
    <>
      <GlobalTooltipStyle suppressMultiMountWarning />
      <DarkTheme suppressMultiMountWarning />
      <LightTheme suppressMultiMountWarning />
      <DarkGrayTheme suppressMultiMountWarning />
      <RCTooltip
        {...internalProps}
        overlayClassName={className}
        prefixCls={TOOLTIP_CLASS_PREFIX}
        align={{ offset }}
        ref={tooltipRef}
        {...props}
        trigger={trigger}
        transitionName="bl-tooltip-fade"
        arrowContent={<div className="bl-tooltip-arrow-inner" />}
        mouseEnterDelay={mouseEnterDelay}
      >
        {children}
      </RCTooltip>
    </>
  );
});

Tooltip.propTypes = {
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  hover: PropTypes.bool,
  overlayClass: PropTypes.string,
  placement: PropTypes.string,
  offset: PropTypes.array,
  hide: PropTypes.bool,
  theme: PropTypes.string,
  mouseEnterDelay: PropTypes.number,
  withPaddings: PropTypes.bool,
  tooltipRef: PropTypes.object,
};
Tooltip.defaultProps = {
  placement: PLACEMENT_ENUM.RIGHT,
  trigger: TRIGGER_ENUM.HOVER,
  theme: THEME_ENUM.DARK,
  mouseEnterDelay: TOOLTIP_DELAY,
  hover: false,
  withPaddings: true,
};
